<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="materialForm"
          :model="material"
          label-width="90px"
          size="small"
          class="box"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="16">
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.serialNo')"
                      :prop="'serialNo'"
                      :rules="[
                        {
                          required: true,
                          validator: validateSerialNo,
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input size="small" v-model.trim="material.serialNo" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.name')"
                      :prop="'unit'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [$t('material.name')]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-autocomplete
                        size="small"
                        v-model.trim="material.name"
                        style="width: 100%"
                        :fetch-suggestions="querySearchNames"
                        @select="handleSelectNames"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.subject')"
                      :prop="'subjectId'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('material.subject'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-select
                        size="small"
                        v-model.trim="material.subjectId"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="subject in subjects"
                          :key="subject.id"
                          :label="subject.name"
                          :value="subject.id"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.inUnit')"
                      :prop="'unit'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('material.inUnit'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-autocomplete
                        size="small"
                        v-model.trim="material.inUnit"
                        style="width: 100%"
                        :fetch-suggestions="querySearchInUnits"
                        @select="handleSelectInUnits"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.outUnit')"
                      :prop="'unit'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('material.outUnit'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-autocomplete
                        size="small"
                        v-model.trim="material.unit"
                        style="width: 100%"
                        :fetch-suggestions="querySearchUnits"
                        @select="handleSelectUnits"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.exchange')"
                      :prop="'exchange'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('material.exchange'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input size="small" v-model.trim="material.exchange" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.color')"
                      :prop="'color'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [$t('material.color')]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-autocomplete
                        size="small"
                        v-model.trim="material.color"
                        style="width: 100%"
                        :fetch-suggestions="querySearchColors"
                        @select="handleSelectColors"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('material.colorNo')"
                      :prop="'colorNo'"
                      :rules="[
                        {
                          required: true,
                          message: $t('rules.required', [
                            $t('material.colorNo'),
                          ]),
                          trigger: 'blur',
                        },
                      ]"
                    >
                      <el-input size="small" v-model.trim="material.colorNo" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('product.images')">
                  <upload-single-picture v-model="material.image" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('material.inPrice')">
                  <el-input size="small" v-model.trim="material.inPrice" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('material.handCycle')">
                  <el-input
                    size="small"
                    v-model.trim="material.minHandCycle"
                    style="width: 85px"
                  />
                  -
                  <el-input
                    size="small"
                    v-model.trim="material.maxHandCycle"
                    style="width: 85px"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>{{ $t("text.remark") }}</legend>
            <el-input
              size="small"
              v-model.trim="material.remark"
              type="textarea"
              :rows="2"
            />
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import UploadSinglePicture from "@/components/UploadSinglePicture";

//
import Material from "@/api/material.js";
import SupplierMms from "@/api/supplierMms.js";
import SubjectMms from "@/api/subjectMms.js";
import Color from "@/api/color.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    UploadSinglePicture,
  },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("material.serialNo")]))
        );
        return;
      }

      Material.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.material.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("material.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };
    return {
      validateSerialNo: validateSerialNo,

      material: { serialNo: null },
      subjects: [],
      colors: [],
      saveDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadingStart();
    axios
      .all([
        Material.findById(self.id),
        SubjectMms.findByTenantId(),
        Color.findByTenantId(),
      ])
      .then(
        axios.spread(function (material, subjects, colors) {
          if (material.data.code === 200) {
            self.material = material.data.entity;
          } else {
            self.sysError();
          }
          if (subjects.status === 200) {
            self.subjects = subjects.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
          self.loadingEnd();
        })
      );
  },
  methods: {
    // 品名
    querySearchNames(queryString, cb) {
      Material.getNames().then(function (res) {
        const names = res.data.map((item) => {
          return { value: item };
        });
        cb(names);
      });
    },
    handleSelectNames(item) {
      this.material.name = item.value;
    },
    // 单位
    querySearchUnits(queryString, cb) {
      Material.getUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectUnits(item) {
      this.material.unit = item.value;
    },
    // 单位
    querySearchInUnits(queryString, cb) {
      Material.getInUnits().then(function (res) {
        const units = res.data.map((item) => {
          return { value: item };
        });
        cb(units);
      });
    },
    handleSelectInUnits(item) {
      this.material.inUnit = item.value;
    },
    // 颜色
    querySearchColors(queryString, cb) {
      const self = this;
      const colors = self.colors.map((item) => {
        return { value: item.name };
      });
      cb(colors);
    },
    handleSelectColors(item) {
      this.material.color = item.value;
    },

    saveSubmit() {
      const self = this;
      this.$refs.materialForm.validate((valid) => {
        if (valid) {
          if (
            ((self.material.minHandCycle ?? "") != "" &&
              (self.material.maxHandCycle ?? "") == "") ||
            ((self.material.minHandCycle ?? "") == "" &&
              (self.material.maxHandCycle ?? "") !== "")
          ) {
            self.$message({
              message: "最小货期和最大货期要不都填写，要不都不填写",
              type: "warning",
            });
            return;
          }
          if (
            (self.material.minHandCycle ?? "") != "" &&
            (self.material.maxHandCycle ?? "") !== "" &&
            self.material.minHandCycle > self.material.maxHandCycle
          ) {
            this.$message({
              message: "最大货期必须大于最小货期",
              type: "warning",
            });
            return;
          }
          self.saveDoing = true;
          Material.update(self.material.id, self.material).then(function (res) {
            self.saveDoing = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.$emit("updateInfo", self.material);
              self.$eventHub.$emit("MaterialUpdate");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>